import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Feature} from '../shared';
import {ConfigService} from '../../core';

@Component({
  selector: 'igo-feature-details',
  template: require('./feature-details.component.html'),
  styles: [require('./feature-details.component.styl')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureDetailsComponent {
  infoText = '本系統僅供參考，實際併網核准與否仍需按程序提交相關申請，並交由台電各區營業處審查。'

  @Input()
  get feature(): Feature {
    return this._feature;
  }

  set feature(value: Feature) {
    this._feature = value;
    this.cdRef.detectChanges();
  }

  private _feature: Feature;

  constructor(private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer, private config: ConfigService) {
    this.infoText = this.config.getConfig('featureInfoText') || this.infoText
  }

  isUrl(value): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  isObject(value) {
    return typeof value === 'object';
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/feature-details/feature-details.component.ts